import { useState, useEffect } from 'react';
import type { EventType } from '@sdk/schedule/types/EventType';

export type ToggleEventType = (eventId: string | number) => void;
export type ToggleEventBind = ({ id }: { id: string | number }) => void;
export type IsEventSelectedType = (eventId: string) => boolean;
export type SelectedEventsType = { [key: string]: EventType };

export type UseEventSelection = {
  isEventSelected: IsEventSelectedType;
  hasSelectedEvents: boolean;
  toggleEvent: ToggleEventType;
};

export type UseEventSelectionProps = {
  selectedEvents: SelectedEventsType;
  toggleEventBind: ToggleEventBind;
};

type UseEventSelectionHook = (props: UseEventSelectionProps) => UseEventSelection;

const useEventSelection: UseEventSelectionHook = ({ selectedEvents, toggleEventBind }) => {
  const [hasSelectedEvents, setHasSelectedEvents] = useState(false);

  useEffect(() => {
    const isAnythingSelected = Boolean(
      selectedEvents && Object.values(selectedEvents).filter(Boolean).length
    );
    setHasSelectedEvents(isAnythingSelected);
  }, [selectedEvents]);

  const isEventSelected: IsEventSelectedType = (eventId) =>
    Boolean(selectedEvents && selectedEvents[eventId]);

  const toggleEvent: ToggleEventType = (eventId) => {
    toggleEventBind({ id: eventId });
  };

  return {
    isEventSelected,
    hasSelectedEvents,
    toggleEvent,
  };
};

export default useEventSelection;
